import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {useIntl} from 'react-intl';
import classnames from 'classnames';
import {FieldArray} from 'formik';
import {InputTypeahead} from '../FieldInputTypeahead';
import CustomerItem from '../CustomerItem';
import Empty from '../Empty';
import {getCustomerDetails} from '../../utils/getCustomerDetails';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import * as actions from '../../actions/findCustomers';
import styles from './styles.module.scss';

const FieldFindCustomers = ({
                              formik,
                              name,
                              customContainerStyles = 'w-100',
                              customListStyles = '',
                              readOnlyMode = false,
                              customLabel,
                              showEmptyMessage = true,
                            }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const [inputValue, setInputValue] = useState('');

  return (
    <div className={customContainerStyles}>
      <FieldArray name={name}>
        {({unshift, remove}) => {
          const currentCustomers = formik.values[name] || [];

          const customerNotInList = (customer) => {
            return !currentCustomers.some(c => c.customerID === customer.customerID);
          };

          const handleAdd = ([value]) => {
            if (!value) return;
            if (customerNotInList(value)) {
              unshift(value);
              formik.setTouched({[name]: true});
            }
            setInputValue('');
          };

          return (
            <>
              {!readOnlyMode && (
                <InputTypeahead
                  id={`inputValue`}
                  value={inputValue}
                  isLoading={false}
                  labelKey={option => `${option.firstName} ${option.lastName}`}
                  onChange={handleAdd}
                  onInputChange={setInputValue}
                  renderMenuItemChildren={option => <CustomerItem {...option} />}
                  handleFindItem={(input) => dispatch(actions.findCustomer(input))}
                  label={
                    <div className={styles.label}>
                      {customLabel || intl.formatMessage({
                        id: 'typeahead-customer-label',
                        defaultMessage: 'Search customers'
                      })}
                    </div>
                  }
                />
              )}

              <div className={classnames(styles.addedCustomersContainer, customListStyles)}>
                {currentCustomers.length > 0 ? (
                    currentCustomers.map((customer, index) => (
                      <div key={index} className={styles.selectedItem}>
                        <div className={styles.info}>
                          <div className={styles.line}>
                            <img
                              src={toAbsoluteUrl(`/media/common/${customer?.greenInvoiceClientID ? 'GI-logo.svg' : 'User_primary.svg'}`)}
                              alt="i"
                            />
                            <span>{getCustomerDetails(customer).name}</span>
                          </div>
                          <div className={styles.line}>
                            <img src={toAbsoluteUrl('/media/common/Id-badge_primary.svg')} alt="i"/>
                            <span>{getCustomerDetails(customer).idNumber}</span>
                          </div>
                          <div className={styles.line}>
                            <img src={toAbsoluteUrl('/media/common/Phone_primary.svg')} alt="i"/>
                            <span>{getCustomerDetails(customer).phone}</span>
                          </div>
                          <div className={styles.line}>
                            <img src={toAbsoluteUrl('/media/common/Email_primary.svg')} alt="i"/>
                            <span>{getCustomerDetails(customer).email}</span>
                          </div>
                        </div>
                        {!readOnlyMode && (
                          <img
                            src={'../../../media/common/Delete_red.svg'}
                            alt="remove"
                            onClick={() => remove(index)}
                            className={'h-20px ml-4 cursor-pointer'}
                          />
                        )}
                      </div>
                    )))
                  : (showEmptyMessage &&
                    <Empty
                      message={intl.formatMessage({
                        id: 'inspection-details-page-search-customers-nothing-old-shuma',
                        defaultMessage: 'No data'
                      })}
                    />
                  )
                }
              </div>
            </>
          );
        }}
      </FieldArray>
    </div>
  );
};

export default FieldFindCustomers;
